import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";

export const AmenitiesBookingStyles = makeStyles((theme) => (
    {

        root: {
            padding: "0px",
            backgroundColor: "#F2F5FA",
        },
        roots: {
            margin: "0px 12px",
            padding: "12px 0px 0px 5px",
            overflow: "scroll",
        },
        image: {
            objectFit: "cover",
            width: "64px",
            borderRadius: theme.palette.borderRadius,
            height: "60px",
            border: "1px solid #5C86CB2E",
        },
        card: {
            backgroundColor: "white",
            // padding: "16px 16px 9px 16px",
            padding: "16px 0px",
            marginTop: "12px",
            borderRadius: "16px",
        },
        name: {
            fontSize: "1rem",
            fontFamily: FontFamilySwitch().bold,
            color: theme.typography.color.Tertiary,
            marginBottom: "8px"

        },
        total: {
            fontSize: "1rem",
            fontFamily: FontFamilySwitch().bold,
            color: "#071741",
            marginTop: "12px",
        },
        arrow: {
            border: "1px solid #E4E8EE",
            backgroundColor: "#F2F4F7",
            fontSize: "0.75rem",
        },
        noData: {
            color: "#999",
            textAlign: "center",
            marginTop: "20vh",
            fontSize: "0.875rem",
            fontFamily: FontFamilySwitch().bold,
            marginLeft: "12px"
        },
        slots: {
            backgroundColor: "white",
            padding: "14px",
            borderRadius: "4px",
            marginTop: "14px",
            boxShadow: "0px 3px 30px #5C86CB2E",
        },
        titles: {
            fontSize: "1rem",
            fontFamily: FontFamilySwitch().bold,
            color: theme.typography.color.primary,
        },
        modalTitle: {
            fontSize: "1rem",
            fontFamily: FontFamilySwitch().extraBold,
            color: theme.typography.color.primary,
        },
        title2: {
            fontSize: "0.75rem",
            fontFamily: FontFamilySwitch().semiBold,
            color: theme.typography.color.primary,
        },
        totalAmount: {
            fontSize: "1.125rem",
            fontFamily: FontFamilySwitch().bold,
            color: theme.typography.color.primary,
        },

        subTitle: {
            fontSize: "0.75rem",
            fontFamily: FontFamilySwitch().semiBold,
            color: theme.typography.color.secondary,
        },
        drawer: {
            "& .MuiDrawer-paper": {
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                padding: "0px",
            },
        },
        dialog: {
            "& .MuiDialog-paper": {
                borderRadius: "4px",
                padding: "0px",
            },
        },
        Cardcontent: {
            [theme.breakpoints.up("sm")]: {
                padding: "12px",
                backgroundColor: "#F5F7FA"

            },

            [theme.breakpoints.down("sm")]: {
                padding: "12px",
                backgroundColor: "#F5F7FA"
            },
        },
        btn: {
            borderRadius: theme.palette.borderRadius,
            padding: "10px"
        },
        flex: {
            display: "flex",
            alignItems: "center"
        },
        justifyContent: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px"
        },
        flexWithPadding: {
            display: "flex",
            padding: "8px",
            borderBottom: "1px solid #c1c1c1",
            alignItems: "center"
        },
        divider: {
            backgroundColor: "#F2F4F7",
            height: "4px",
            margin: "8px 0px"
        },
        dot: {
            height: "6px",
            width: "6px",
            borderRadius: "50%",
            backgroundColor: "red",
            // margin: "6px 6px 6px 8px",
            margin:"auto"
        },
        tabroot: {
            display: "flex",
            alignItems: "center",
            "& .MuiTabs-indicator": {
                display: "none"
            }
        },
        tabItemroot: {

            "& .MuiButtonBase-root-MuiTab-root": {
            },

        },
        tabItem: {
            borderRadius: "4px",
            padding: "8px",
            minHeight: "auto",
            minWidth: "auto",
            maxHeight: "68px",
            margin: "0px 14px",
            "& .MuiButtonBase-root-MuiTab-root": {
                borderRadius: "4px",
            },

        },
        tabItemSelect: {

            backgroundColor: "#F2F5FA",
            borderRadius: "6px",
            padding: "6px 8px",
            minHeight: "auto",
            minWidth: "auto",
            maxHeight: "82px",
            margin: "0px 14px",
            "& .MuiButtonBase-root-MuiTab-root": {
                minHeight: 0,
                borderRadius: "4px",

            },
        },
        textSelect1: {
            color: theme.palette.primary.main,
            fontFamily: FontFamilySwitch().semiBold,
            fontSize: "0.75rem"
        },
        textSelect2: {
            color: theme.palette.primary.main,
            fontSize: "1.125rem"
        },
        textNotSelect1: {
            color: theme.typography.color.Tertiary,
            fontFamily: FontFamilySwitch().semiBold,
            fontSize: "1rem"
        },
        dueSect:{
            color: "#5D427F",
            fontFamily: FontFamilySwitch().bold,
            fontSize: "0.75rem",
            backgroundColor:"#F1E6FE",
            width:"60%",
            textAlign:"center",
            padding:"3px 6px",
            borderRadius:"6px"

        },
        textNotSelect2: {
            color: theme.typography.color.secondary,
            fontSize: "1.125rem"
        },
        panel: {
            padding: "12px !important"
        },
        box: {
            display: "flex",
            alignItems: "center",
            backgroundColor: "white",
            padding: "12px 16px",
            borderRadius: "16px",
            marginBottom: "14px",
            cursor: "pointer",
            height:"84px"
        },
        tagStyle: {
            backgroundColor: "#F1E6FE",
            borderRadius: "4px",
            padding: "4px 6px 4px 6px",
            fontSize: "0.75rem",
            fontFamily: FontFamilySwitch().bold,
            color: "#5D427F",
            marginRight: "16px",

        },
        borderGrid: {
            display: "flex",
            borderBottom: "2px dashed #CED3DD",
            borderTop: "2px dashed #CED3DD",
            padding: "12px 0px",
            marginLeft: "10px"
        }
    }));
